module.exports = __webpack_public_path__ + "img/semin_energia.7a7f1099.jpg";